export default __webpack_public_path__ + "static/media/newsletter-hero.e75281fc.png";